// components/PlaceGallery.jsx
import React, { useState, useEffect } from "react";
import "./carousel.scss";
import { Carousel } from "react-responsive-carousel";
import PropTypes from "prop-types";
import styles from "./PlaceGallery.module.scss";
import localforage from "localforage";
import { STORAGE_KEYS } from "../../constants/storage";

const PlaceGallery = ({ images }) => {
  const [cachedImages, setCachedImages] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [createdUrls, setCreatedUrls] = useState([]);

  useEffect(() => {
    const loadCachedImages = async () => {
      try {
        setIsLoading(true);

        // Clear previous URLs before creating new ones
        createdUrls.forEach((url) => {
          if (url.startsWith("blob:")) {
            URL.revokeObjectURL(url);
          }
        });
        setCreatedUrls([]);

        const cachedUrls = await Promise.all(
          images.map(async (src) => {
            const cachedImage = await localforage.getItem(
              `${STORAGE_KEYS.GALLERY_IMAGES}_${src}`
            );
            if (cachedImage) {
              const blobUrl = URL.createObjectURL(cachedImage);
              return blobUrl;
            }
            return src;
          })
        );

        setCachedImages(cachedUrls);
        setCreatedUrls(cachedUrls.filter((url) => url.startsWith("blob:")));
      } catch (error) {
        console.error("Error loading images from cache:", error);
        setCachedImages(images);
        setCreatedUrls([]);
      } finally {
        setIsLoading(false);
      }
    };

    if (images && images.length > 0) {
      loadCachedImages();
    }

    // Clean up URLs when component unmounts
    return () => {
      createdUrls.forEach((url) => {
        if (url.startsWith("blob:")) {
          URL.revokeObjectURL(url);
        }
      });
    };
  }, [images]);

  if (!images || images.length === 0) {
    return <div>No images available</div>;
  }

  if (isLoading) {
    return <div>Loading images...</div>;
  }

  return (
    <div className={styles.galleryContainer}>
      <Carousel
        autoFocus={false}
        autoPlay={true}
        dynamicHeight={true}
        infiniteLoop={true}
        showArrows={false}
        centerMode={false}
        showStatus={false}
        showThumbs={false}
        showIndicators={true}
        stopOnHover={false}
        swipeable={true}
        interval={5000}
      >
        {cachedImages.map((src, index) => (
          <div key={index}>
            <img src={src} alt={`Gallery image ${index + 1}`} />
          </div>
        ))}
      </Carousel>
    </div>
  );
};

PlaceGallery.propTypes = {
  images: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default PlaceGallery;
